
export default (name) => {
  return name.replace(/(?:^|\s)\S/g, function (a) { return a.toUpperCase() })
}
